import React from 'react';
import withIcon from '../utilities/withIcon';

const IconComment = () => {
  return (
    <g>
      <path d="M9.759.004 6.244 0A6.247 6.247 0 0 0 0 6.25l.004.229a6.253 6.253 0 0 0 6.247 6.027h.999v2.742a.75.75 0 0 0 1.075.677l2.302-1.11A9.498 9.498 0 0 0 16 6.259 6.251 6.251 0 0 0 9.759.004zm-3.51 1.497 3.508.005A4.75 4.75 0 0 1 14.5 6.258l-.005.288a7.996 7.996 0 0 1-4.519 6.917l-1.226.59v-2.298a.75.75 0 0 0-.75-.75H6.25a4.753 4.753 0 0 1 0-9.504z" />
    </g>
  );
};

export default withIcon(IconComment);
